import axiosServices from './request';

const LabelApi = axiosServices('labelcenter/v1.0');

export default {
  /** 获取标签（专业及深度） */
  labelGroupList: LabelApi('get', 'label/labelGroupList'),
  /** 获取标签（目的 */
  purLabelList: LabelApi('get', 'label/purLabelList')
};